<!-- <div *ngFor="let value of elementsValues">
	<span  class="badge-light badge-pill margin-right">{{value | translate}}</span>
</div> -->
<mat-chip-list aria-label="Fish selection">
	<mat-chip color="primary" selected *ngFor="let value of elementsValues" style="height:auto">{{value | translate}}</mat-chip>
	<!-- <mat-chip>Two fish</mat-chip>
	<mat-chip color="primary" selected>Primary fish</mat-chip>
	<mat-chip color="accent" selected>Accent fish</mat-chip> -->
</mat-chip-list>